angular.module('app.filters').filter('ucfirst', () => (input) => {
    if (!input) {
        return null;
    }
    return input.substring(0, 1).toUpperCase() + input.substring(1);
});
